import { useTranslationAdminDashboard } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { Box, Button, Container, Space, Text, Title } from '@mantine/core';
import { TEST_ELEMENT_IDS } from '@dealstack/frontend/shared/helper/UIElementIdentifier/UIElementIdentifier.tsx';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { useAppSelector } from '@dealstack/frontend/app/hooks/redux';

export const DashboardSidebar = styled(({ className }: { className?: string }) => {
	const userState = useAppSelector((state) => state.user);
	const tAdminDashboard = useTranslationAdminDashboard();
	const navigate = useNavigate();

	return (
		<Container
			miw="19rem"
			maw="19rem"
			pl="2rem"
			pr="2rem"
			pt="2rem"
			ml={0}
			h="100%"
			className={className}
		>
			<Title maw="14rem" size="h1" fw={200}>
				{tAdminDashboard('v3.sidebar.welcome')}{' '}
				<Text
					span
					inherit
					fw={400}
					data-testid={TEST_ELEMENT_IDS.ADMIN_DASHBOARD_PAGE_WELCOME_NAME}
				>
					{userState?.data?.firstName} {userState?.data?.lastName}
				</Text>
			</Title>
			<Space h="2rem" />
			<Box>
				<Button
					onClick={() => navigate(ROUTES.DEAL_CREATE)}
					size="md"
					variant="filled"
					leftSection={<Icon variant="add" size="lg" />}
					data-testid={TEST_ELEMENT_IDS.ADMIN_DASHBOARD_PAGE_CREATE_PROJECT_BUTTON}
				>
					{tAdminDashboard('v3.sidebar.new_deal')}
				</Button>
				<Space h="0.5rem" />
			</Box>
		</Container>
	);
})`
	background-color: ${({ theme }) => theme.v2.color.neutral[100]};
`;
